import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n';
// Self-hosted fonts (bundled by Vite, served from our own origin — no Google CDN)
import '@fontsource-variable/manrope/index.css';
import '@fontsource-variable/material-symbols-outlined/full.css';
import './index.css';

// Security: Prevent clickjacking
if (window.self !== window.top) {
  window.top!.location.href = window.self.location.href;
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
